import TintBadge, { TTintBadgeColor } from '@shared/components/TintBadge';
import { PROJECT_STATUS_METADATA } from '../constants';
import { EProjectStatus } from '../types';

const STATUS_COLORS: Record<EProjectStatus, TTintBadgeColor> = {
  [EProjectStatus.PLANNING]: 'informative',
  [EProjectStatus.ACTIVE]: 'blue',
  [EProjectStatus.COMPLETED]: 'success',
  [EProjectStatus.CANCELLED]: 'danger',
};

const ProjectStatusBadge = ({ status }: { status: EProjectStatus }) => (
  <TintBadge color={STATUS_COLORS[status]}>{PROJECT_STATUS_METADATA[status].label}</TintBadge>
);

export default ProjectStatusBadge;
